export default {
      id: "ic_star_favorited-usage",
      viewBox: "2 2 20 20",
      url: "/" + "images/icons.3.109.2.svg#ic_star_favorited-usage",
      toString: function () {
        return this.url;
      }
    }